export const JSONToCSSVariables = (
    obj, prefix="--", asArray=  false
)=>{
    const arr =  Object.entries(obj).reduce((acc, [key, value])  => [...acc,  ...typeof value==='object' ?JSONToCSSVariables(value, `${prefix}${key}-`, false): [`${prefix}${key}: ${value};`]], [])
    return asArray ?arr : arr.join('')
}
